var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 309,
    height: 187,
    viewBox: "0 0 309 187",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10917",
    "data-name": "Group 10917",
    transform: "translate(-510 -1013)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "placeholder-course",
    width: 309,
    height: 187,
    rx: 2,
    transform: "translate(510 1013)",
    fill: "#f3f7f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_30_",
    "data-name": "svgexport-6 (30)",
    transform: "translate(623 1065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10264",
    "data-name": "Group 10264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10263",
    "data-name": "Group 10263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10594",
    "data-name": "Path 10594",
    d: "M41.941,0A41.941,41.941,0,1,0,83.881,41.941,41.941,41.941,0,0,0,41.941,0ZM59.6,43.277a3,3,0,0,1-1.345,1.345v.015L34.293,56.62a3,3,0,0,1-4.335-2.7V29.958a3,3,0,0,1,4.335-2.681L58.259,39.26A3,3,0,0,1,59.6,43.277Z",
    fill: "#dde1e2"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlaceholder);
export default __webpack_public_path__ + "static/media/video-placeholder.631a49d385337ab367f8abe6226ed5e8.svg";
export { ForwardRef as ReactComponent };